import { PictureDesktopNames, PictureTransformations, SelectionGroupOption } from 'common/components';
import { COMPARTMENT_DOORS_GALLERY_LIST_PRESET } from './compartment-doors';
import { SLIDING_WARDROBES_GALLERY_LIST_PRESET } from './sliding-wardrobes';
import { WARDROBES_GALLERY_LIST_PRESET } from './wardrobes';
import { ImagePreset } from './cabinet-gallery-types';
import { HINGED_WARDROBES_GALLERY_LIST_PRESET } from './hinged-wardrobes';

export const ALL_IMAGE_LIST_PRESET: ImagePreset[] = [
  ...SLIDING_WARDROBES_GALLERY_LIST_PRESET,
  ...COMPARTMENT_DOORS_GALLERY_LIST_PRESET,
  ...WARDROBES_GALLERY_LIST_PRESET,
  ...HINGED_WARDROBES_GALLERY_LIST_PRESET,
];

export const SELECTION_GROUP_LIST: SelectionGroupOption[] = [
  { text: 'Все', value: 'all' },
  { text: 'Шкафы-купе', value: 'sliding-wardrobes' },
  { text: 'Двери-купе', value: 'compartment-doors' },
  { text: 'Гардеробные', value: 'wardrobes' },
  { text: 'Распашные шкафы', value: 'hinged-wardrobes' },
];

export const CABINET_BIG_IMAGE_TRANSFORMATIONS: PictureTransformations = {
  [PictureDesktopNames.ImgLargeDesk]: {
    width: 578,
    height: 772,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgDesk]: {
    width: 458,
    height: 772,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgTablet]: {
    width: 318,
    height: 540,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgMobile]: {
    width: 288,
    height: 216,
    objectFit: 'fill',
    dpr: '2.0',
  },
};

export const CABINET_IMAGE_TRANSFORMATIONS: PictureTransformations = {
  [PictureDesktopNames.ImgLargeDesk]: {
    width: 578,
    height: 328,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgDesk]: {
    width: 458,
    height: 328,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgTablet]: {
    width: 318,
    height: 216,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgMobile]: {
    width: 288,
    height: 216,
    objectFit: 'fill',
    dpr: '2.0',
  },
};
